import React from 'react';
// @ts-ignore
import { ButtonWithIcon } from '@els/els-react--button';
import { useDispatch } from 'react-redux';
import { loginFlow } from '../../../login/login-thunk';

const LearningCardLogoutView = (props: any) => {
    const { baseClassName } = props;
    const dispatch = useDispatch();
    return (
        <div className={`${baseClassName}__card-content`}>
            <p className={`${baseClassName}__card-content__header`}>
                Our goal at Elsevier is to provide you with an optimal learning
                & development experience.
            </p>
            <p className={`${baseClassName}__card-content__section`}>
                Please use your login information to sign in.
            </p>
            <ButtonWithIcon
                className={`${baseClassName}__card-content__button`}
                sprite="ChevronRight"
                iconRight
                type="secondary"
                onClick={() => dispatch(loginFlow())}
            >
                Sign in
            </ButtonWithIcon>
        </div>
    );
};

export default LearningCardLogoutView;
